import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { Fragment } from 'react';

export const BookingViewType = ({ data }: any) => {
  const categories = data?.items?.map((item: any) => item?.Name) || [];
  const percentages =
    data?.items?.map((item: any) => item?.Percentage ?? 0) || [];

  // Define the colors you want to cycle through
  const colors = ['#E55050', '#008048'];

  // Create series data with color assigned to each point
  const seriesData = percentages.map((value: number, index: number) => ({
    y: value,
    color: colors[index % colors.length], // Cycle through colors
  }));

  const options: Highcharts.Options = {
    chart: {
      type: 'column',
      height: 400,
    },
    title: {
      text: 'Booking View Type (%)',
      align: 'center',
      style: {
        fontSize: '13px',
      },
    },
    xAxis: {
      categories,
      title: { text: null },
      crosshair: true,
      labels: {
        style: {
          fontSize: '11px',
        },
      },
    },
    yAxis: {
      min: 0,
      max: 100,
      title: {
        text: 'Percentage',
      },
      labels: {
        format: '{value}%',
      },
    },
    tooltip: {
      pointFormat: '<b>{point.y:.2f}%</b>',
    },
    plotOptions: {
      column: {
        dataLabels: {
          enabled: false,
          format: '{y:.2f}%',
        },
      },
    },
    legend: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    series: [
      {
        name: 'Percentage',
        type: 'column',
        data: seriesData,
        colorByPoint: false, // Needed to respect individual color settings
      },
    ],
  };

  return (
    <Fragment>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </Fragment>
  );
};
